import { defineStore } from 'pinia'
import actions from './actions.js';
import mutations from './mutations.js';
import getters from './getters.js';


export const quizStore = defineStore('quizStore', {
    state: () => {
        return {
            // this is for opening quiz based on types
            quizModalType: null,
            quizModalSubType: null,
            //this is to keep track of back navigation
            selectedQuiz: null,
            selectedSubQuiz: null,
            isLoading: false,
            cyo: {
                ring: {
                    totalScreens: 0,
                    currentScreen: 0,
                    screens: {
                        metal: {
                            title: "Engagement Rings",
                            subtitle: "No Guesswork. Just the Right Choice",
                            message: "What metal type would you like?",
                            url: 'Metal',
                            description: "",
                            type: 'select',
                            options: [],

                        },
                        style: {
                            title: "Engagement Rings",
                            subtitle: "No Guesswork. Just the Right Choice",
                            message: "Which ring style best reflects your taste?",
                            url: 'Style',
                            description: "",
                            type: 'multiselect',
                            options: [],
                        },
                        price: {
                            title: "Engagement Rings",
                            subtitle: "No Guesswork. Just the Right Choice",
                            message: "What’s your estimated budget?",
                            url: 'Price',
                            description: "",
                            type: 'price',
                            options: {
                                min: 0,
                                max: 0,
                                from: 0,
                                to: 0
                            },

                        },
                        shape: {
                            title: "Engagement Rings",
                            subtitle: "No Guesswork. Just the Right Choice",
                            message: "What diamond shape do you prefer?",
                            url: 'Shape',
                            description: "",
                            type: 'select',
                            options: [],
                        },
                        quality: {
                            title: "Engagement Rings",
                            subtitle: "No Guesswork. Just the Right Choice",
                            url: 'Quality',
                            message: "What is your priority when buying a diamond?",
                            description: "",
                            type: 'quality',
                            options: [
                                {
                                    label: 'Size',
                                    value: 'size',
                                    icon: 'size',
                                    alt: 'size',
                                    short_desc: 'Bigger Appearance',
                                    active: 0,
                                    disable: 1,
                                    isRecommended: false,   
                                    url: 'size',
                                    payload: {
                                        Sort: 'CaratHigh',
                                    }
                                },
                                {
                                    label: 'Balance',
                                    value: 'balance',
                                    icon: 'balance',
                                    alt: 'balance',
                                    short_desc: 'Balance of Size & Quality',
                                    active: 0,
                                    disable: 1,
                                    isRecommended: true,
                                    url: 'Balance',
                                    payload: {
                                        Sort: 'PriceLow',
                                        DiamondQuality:'FG-VS'
                                    }
                                },
                                {
                                    label: 'Quality',
                                    value: 'quality',
                                    icon: 'quality',
                                    alt: 'quality',
                                    short_desc: 'Best Color + Clarity',
                                    active: 0,
                                    disable: 1,
                                    isRecommended: false,
                                    url: 'quality',
                                    payload: {
                                        Sort: 'PriceLow',
                                        DiamondQuality:'DE-VVS'
                                    }
                                },


                            ],

                        },
                        email: {
                            title: "Engagement Rings",
                            subtitle: "No Guesswork. Just the Right Choice",
                            url: 'Email',
                            value: 'email',
                            message: 'Would you like to receive expertly handpicked recommendations  straight to your inbox?',
                            successMessage: 'Your inbox just got brighter! Your personalized engagement ring shortlist has been sent.',
                            email: "",
                            type: 'email'
                        },
                    }
                },
                diamond: {
                    totalScreens: 0,
                    currentScreen: 0,
                    screens: {
                        price: {
                            message: "What’s your estimated budget?",
                            url: 'Price',
                            title: "Diamond Quiz",
                            subtitle: "No Guesswork. Just the Right Choice",
                            description: "",
                            type: 'price',
                            options: {
                                min: 0,
                                max: 0,
                                from: 0,
                                to: 0
                            },

                        },
                        shape: {
                            message: "What diamond shape do you prefer?",
                            title: "Diamond Quiz",
                            subtitle: "No Guesswork. Just the Right Choice",
                            url: 'Shape',
                            description: "",
                            type: 'select',
                            options: [],
                        },
                        quality: {
                            url: 'Quality',
                            title: "Diamond Quiz",
                            subtitle: "No Guesswork. Just the Right Choice",
                            message: "What is your priority when buying a diamond?",
                            description: "",
                            type: 'quality',
                            options: [
                                {
                                    label: 'Size',
                                    value: 'size',
                                    icon: 'size',
                                    alt: 'size',
                                    short_desc: 'Bigger Appearance',
                                    active: 0,
                                    disable: 1,
                                    isRecommended: false,
                                    url: 'size',
                                    payload: {
                                        Clarity: 'SI1,VS2,VS1,VVS2,VVS1,IF,FL',
                                        Cut: 'EX,ID',
                                        Color: 'H,G,F,E,D',
                                        CaratFrom: 1,
                                        CaratTo: 29.18,
                                        Sort: 'CaratHigh',
                                    }
                                },
                                {
                                    label: 'Balance',
                                    value: 'balance',
                                    icon: 'balance',
                                    alt: 'balance',
                                    short_desc: 'Balance of Size & Quality',
                                    active: 0,
                                    disable: 1,
                                    isRecommended: true,
                                    url: 'Balance',
                                    payload: {
                                        Clarity: 'VS1,VVS2,VVS1,IF',
                                        Cut: 'EX,ID',
                                        Color: 'F,E,D',
                                        CaratFrom: 1,
                                        CaratTo: 29.18,
                                        Sort: 'CaratHigh',
                                    }
                                },
                                {
                                    label: 'Quality',
                                    value: 'quality',
                                    icon: 'quality',
                                    alt: 'quality',
                                    short_desc: 'Best Color + Clarity',
                                    active: 0,
                                    disable: 1,
                                    isRecommended: false,
                                    url: 'quality',
                                    payload: {
                                        Clarity: 'VVS1,IF',
                                        Cut: 'EX,ID',
                                        Color: 'D',
                                        CaratFrom: 1,
                                        CaratTo: 29.18,
                                        Sort: 'CaratHigh',
                                    }
                                },


                            ],

                        },
                        email: {
                            url: 'Email',
                            value: 'email',
                            title: "Diamond Quiz",
                            subtitle: "No Guesswork. Just the Right Choice",
                            message: 'Would you like to receive expertly handpicked recommendations  straight to your inbox?',
                            successMessage: 'Your inbox just got brighter! Your personalized diamond shortlist has been sent.',
                            email: "",
                            type: 'email'
                        },
                        result: {
                            url: 'Result',
                            title: "Diamond Quiz",
                            subtitle: "No Guesswork. Just the Right Choice",
                            description: "",
                            message: 'Choose a diamond to add to your setting.',
                            options: [],
                            result: [],

                            type: null
                        }
                    }
                },
            },
            shop: {
                ring: {
                    totalScreens: 0,
                    currentScreen: 0,
                    screens: {
                        style: {
                            title: "Fine Jewelry",
                            subtitle: "No Guesswork. Just the Right Choice",
                            url: 'Style',
                            message: "What style of rings are you looking for?",
                            type: 'multiselect',
                            options: [],
                        },
                        metal: {
                            title: "Fine Jewelry",
                            subtitle: "No Guesswork. Just the Right Choice",
                            message: "What metal type would you like?",
                            url: 'Metal',
                            description: "",
                            type: 'select',
                            options: [],
                        },
                        price: {
                            title: "Fine Jewelry",
                            subtitle: "No Guesswork. Just the Right Choice",
                            message: "What’s your estimated budget?",
                            url: 'Price',
                            description: "",
                            type: 'price',
                            options: {
                                min: 0,
                                max: 0,
                                from: 0,
                                to: 0
                            },
                        },

                        email: {
                            title: "Fine Jewelry",
                            subtitle: "No Guesswork. Just the Right Choice",
                            url: 'Email',
                            value: 'email',
                            message: 'Would you like to receive expertly handpicked recommendations  straight to your inbox?',
                            successMessage: 'Your inbox just got brighter! Your personalized engagement ring shortlist has been sent.',
                            email: "",
                            type: 'email'
                        },
                    }

                },
                earring: {
                    totalScreens: 0,
                    currentScreen: 0,
                    screens: {
                        style: {
                            title: "Fine Jewelry",
                            subtitle: "No Guesswork. Just the Right Choice",
                            url: 'Style',
                            message: "What style of earrings are you looking for?",
                            type: 'multiselect',
                            options: [],
                        },
                        metal: {
                            title: "Fine Jewelry",
                            subtitle: "No Guesswork. Just the Right Choice",
                            message: "What metal type would you like?",
                            url: 'Metal',
                            description: "",
                            type: 'select',
                            options: [],

                        },
                        price: {
                            title: "Fine Jewelry",
                            subtitle: "No Guesswork. Just the Right Choice",
                            message: "What’s your estimated budget?",
                            url: 'Price',
                            description: "",
                            type: 'price',
                            options: {
                                min: 0,
                                max: 0,
                                from: 0,
                                to: 0
                            },

                        },

                        email: {
                            title: "Fine Jewelry",
                            subtitle: "No Guesswork. Just the Right Choice",
                            url: 'Email',
                            value: 'email',
                            message: 'Would you like to receive expertly handpicked recommendations  straight to your inbox?',
                            successMessage: 'Your inbox just got brighter! Your personalized engagement ring shortlist has been sent.',                            
                            email: "",
                            type: 'email'
                        },
                    }

                },
                necklace: {
                    totalScreens: 0,
                    currentScreen: 0,
                    screens: {
                        style: {
                            title: "Fine Jewelry",
                            subtitle: "No Guesswork. Just the Right Choice",
                            url: 'Style',
                            message: "What style of necklaces are you looking for?",
                            type: 'multiselect',
                            options: [],

                        },
                        metal: {
                            title: "Fine Jewelry",
                            subtitle: "No Guesswork. Just the Right Choice",
                            message: "What metal type would you like?",
                            url: 'Metal',
                            description: "",
                            type: 'select',
                            options: [],

                        },
                        price: {
                            title: "Fine Jewelry",
                            subtitle: "No Guesswork. Just the Right Choice",
                            message: "What’s your estimated budget?",
                            url: 'Price',
                            description: "",
                            type: 'price',
                            options: {
                                min: 0,
                                max: 0,
                                from: 0,
                                to: 0
                            },

                        },

                        email: {
                            title: "Fine Jewelry",
                            subtitle: "No Guesswork. Just the Right Choice",
                            url: 'Email',
                            value: 'email',
                            message: 'Would you like to receive expertly handpicked recommendations  straight to your inbox?',
                            successMessage: 'Your inbox just got brighter! Your personalized engagement ring shortlist has been sent.',
                            email: "",
                            type: 'email'
                        },
                    }
                },
                bracelet: {
                    totalScreens: 0,
                    currentScreen: 0,
                    screens: {
                        style: {
                            title: "Fine Jewelry",
                            subtitle: "No Guesswork. Just the Right Choice",
                            url: 'Style',
                            message: "What style of bracelets are you looking for?",
                            type: 'multiselect',
                            options: [],
                        },
                        metal: {
                            title: "Fine Jewelry",
                            subtitle: "No Guesswork. Just the Right Choice",
                            message: "What metal type would you like?",
                            url: 'Metal',
                            description: "",
                            type: 'select',
                            options: [],

                        },
                        price: {
                            title: "Fine Jewelry",
                            subtitle: "No Guesswork. Just the Right Choice",
                            message: "What’s your estimated budget?",
                            url: 'Price',
                            description: "",
                            type: 'price',
                            options: {
                                min: 0,
                                max: 0,
                                from: 0,
                                to: 0
                            },

                        },

                        email: {
                            title: "Fine Jewelry",
                            subtitle: "No Guesswork. Just the Right Choice",
                            url: 'Email',
                            value: 'email',
                            message: 'Would you like to receive expertly handpicked recommendations  straight to your inbox?',
                            successMessage: 'Your inbox just got brighter! Your personalized engagement ring shortlist has been sent.',
                            email: "",
                            type: 'email'
                        },
                    }

                },
                all: {
                    totalScreens: 0,
                    currentScreen: 0,
                    screens: {
                        metal: {
                            title: "Fine Jewelry",
                            subtitle: "No Guesswork. Just the Right Choice",
                            message: "What metal type would you like?",
                            url: 'Metal',
                            description: "",
                            type: 'select',
                            options: [],
                        },
                        price: {
                            title: "Fine Jewelry",
                            subtitle: "No Guesswork. Just the Right Choice",
                            message: "What’s your estimated budget?",
                            url: 'Price',
                            description: "",
                            type: 'price',
                            options: {
                                min: 0,
                                max: 0,
                                from: 0,
                                to: 0
                            },
                        },
                        email: {
                            title: "Fine Jewelry",
                            subtitle: "No Guesswork. Just the Right Choice",
                            url: 'Email',
                            value: 'email',
                            message: 'Would you like to receive expertly handpicked recommendations  straight to your inbox?',
                            successMessage: 'Your inbox just got brighter! Your personalized engagement ring shortlist has been sent.',
                            email: "",
                            type: 'email'
                        },
                    }

                },
            },

        }

    },

    getters: { ...getters },
    actions: {
        ...actions, commitMutation: function (mutationToCall, data) {

            try {
                mutations[mutationToCall](this, data)
            } catch (error) {
                console.error('DIAMONDQUIZ MUTATION ERROR - ', mutationToCall, data, error)
                throw error
            }
        }
    },

})


